import { motion } from 'framer-motion';

import { complianceBadges } from '@marketing/data/compliance';
import { ComplianceIcon } from '@marketing/illustrations/ComplianceIcon';
import { fadeUp, revealOnView, stagger } from '@marketing/motion/variants';

// ============================================================
// ComplianceBadges — 5 selos legais/regulatórios
// ============================================================

export function ComplianceBadges() {
  return (
    <section
      id="conformidade"
      className="lume-section"
      aria-labelledby="compliance-title"
    >
      <div className="lume-container">
        <motion.header
          {...revealOnView}
          variants={stagger(0.08)}
          className="lume-stack lume-stack-md"
          style={{ marginBottom: 'clamp(2rem, 4vw, 3rem)', maxWidth: '52rem' }}
        >
          <motion.p variants={fadeUp} className="lume-eyebrow">Conformidade & ética</motion.p>
          <motion.h2 variants={fadeUp} id="compliance-title" className="lume-h2 lume-text-balance">
            Conformidade não é etapa — é estado contínuo
          </motion.h2>
          <motion.p variants={fadeUp} className="lume-body-lg lume-text-pretty">
            Cinco frentes ratificadas. Documentação completa em RIPD, ADRs e TCLE/TALE granulares
            disponíveis sob demanda para parceiros institucionais.
          </motion.p>
        </motion.header>

        <motion.div
          {...revealOnView}
          variants={stagger(0.08)}
          className="lume-badges"
        >
          {complianceBadges.map((b) => (
            <motion.article key={b.id} variants={fadeUp} className="lume-badge">
              <ComplianceIcon iconKey={b.iconKey} />
              <h3
                style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: '0.95rem',
                  fontWeight: 700,
                  margin: 0,
                }}
              >
                {b.short}
              </h3>
              <p
                style={{
                  margin: 0,
                  fontSize: '0.78rem',
                  color: 'var(--color-fg-subtle)',
                  letterSpacing: '0.02em',
                }}
              >
                {b.full}
              </p>
              <p
                style={{
                  margin: '0.5rem 0 0',
                  fontSize: '0.85rem',
                  color: 'var(--color-fg-muted)',
                  lineHeight: 1.5,
                }}
              >
                {b.body}
              </p>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
